export const CHIP_DISPLAY_LIMIT_TABLE_ROW = 5;

export const CHIP_LINE_HEIGHT = 16;
export const CHIP_TABLE_CELL_PADDING = 1;
export const CHIP_MINI_PADDING = 3;
export const CHIP_SMALL_PADDING = 5;
